import * as React from 'react';
import { updateSearchFilterValue } from '../mutators/searchViewMutators';
import type { SearchFilterOption } from 'owa-timestream-asset-search';
import type { OwaDate } from 'owa-datetime';

export default function useDatePickerSearchRefinerState({
    option,
}: {
    option: SearchFilterOption;
}) {
    const onChange = React.useCallback(
        (selectedDate: OwaDate) => {
            updateSearchFilterValue(option.id, selectedDate);
        },
        [option.id]
    );

    return {
        onChange: onChange,
    };
}
